import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

document.addEventListener("DOMContentLoaded", () => {
  const blocks = document.querySelectorAll("[slide-fade]");

  blocks.forEach((block) => {
    gsap.from(block, {
      y: 100, // slide depuis le bas
      opacity: 0, // fade in
      duration: 1.2,
      ease: "power4.out",
      scrollTrigger: {
        trigger: block,
        start: "top 85%",
        toggleActions: "play none none none"
      }
    });
  });
});